export const OFFERS_LIST_LIMIT = 12
export const OFFERS_LIST_LIMIT_STEP = 8
export const CLASSIFIEDS_LIST_LIMIT = 8
export const CLASSIFIEDS_LIST_STEP = 4
